export default "/images/chevron-left.svg?982a40d4f9e3cf9fdaeaf4af9da46c14";